export const initialState = {
	commands: [],
	path: "root@Mehdi:~$",
	alert: false,
};
